import { render, staticRenderFns } from "./TaskListItemNew.vue?vue&type=template&id=462d075e&"
import script from "./TaskListItemNew.vue?vue&type=script&lang=js&"
export * from "./TaskListItemNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports